export const Img2BrsNav = {
  label: 'Img2Brs',
  description: 'Convert images into Brickadia save files!',
  url: '/tools/img2brs',
  metadata: {
    title: 'Img2Brs - Aware.dev',
    description: 'Convert images into Brickadia Saves!',
    meta: [
      { property: 'og:title', content: 'Img2Brs' },
      { property: 'og:description', content: 'Convert images into Brickadia Saves!' },
      { property: 'og:url', content: 'https://aware.dev/tools/img2brs' },
      { property: 'og:image', content: 'https://i.imgur.com/OHaRlCM.png' },
      { property: 'og:image:alt', content: 'Img2Brs Logo' },
    ]
  },
  children: []
}

export const IllegalGeneratorNav = {
  label: 'Brick Generator',
  description: 'Create bricks for Brickadia that you can\'t normally make.',
  url: '/tools/brickgen',
  metadata: {
    title: 'Brick Generator - Aware.dev',
    description: 'Create bricks for Brickadia that you can\'t normally make.',
    meta: [
      { property: 'og:title', content: 'Brick Generator' },
      { property: 'og:description', content: 'Create bricks for Brickadia that you can\'t normally make.' },
      { property: 'og:url', content: 'https://aware.dev/tools/brickgen' },
      // { property: 'og:image', content: 'https://i.imgur.com/OHaRlCM.png' },
      // { property: 'og:image:alt', content: 'Img2Brs Logo' },
    ]
  },
  children: []
}

export const Brs2JsonNav = {
  label: 'Brs2Json',
  description: 'Convert BRS files into JSON',
  url: '/tools/brs2json',
  metadata: {
    title: 'Brs2Json- Aware.dev',
    description: 'Convert BRS files into JSON.',
    meta: [
      { property: 'og:title', content: 'Brs2Json' },
      { property: 'og:description', content: 'Convert BRS files into JSON.' },
      { property: 'og:url', content: 'https://aware.dev/tools/brs2json' },
      // { property: 'og:image', content: 'https://i.imgur.com/OHaRlCM.png' },
      // { property: 'og:image:alt', content: 'Img2Brs Logo' },
    ]
  },
  children: []
}

export const Json2BrsNav = {
  label: 'Json2Brs',
  description: 'Convert JSON files into BRS',
  url: '/tools/json2brs',
  metadata: {
    title: 'Json2Brs- Aware.dev',
    description: 'Convert JSON files into BRS.',
    meta: [
      { property: 'og:title', content: 'Json2Brs' },
      { property: 'og:description', content: 'Convert JON files into BRS.' },
      { property: 'og:url', content: 'https://aware.dev/tools/json2brs' },
    ]
  },
  children: []
}

export const VersionNav = {
  label: 'A4izer',
  description: 'Convert QA to A4.',
  url: '/tools/a4izer',
  metadata: {
    title: 'A4izer- Aware.dev',
    description: 'Convert QA to A4.',
    meta: [
      { property: 'og:title', content: 'A4izer' },
      { property: 'og:description', content: 'Convert QA to A4.' },
      { property: 'og:url', content: 'https://aware.dev/tools/a4izer' },
      // { property: 'og:image', content: 'https://i.imgur.com/OHaRlCM.png' },
      // { property: 'og:image:alt', content: 'Img2Brs Logo' },
    ]
  },
  children: []
}

export const MirrorNav = {
  label: 'Mirror',
  description: 'Mirror .brs saves.',
  url: '/tools/mirror',
  metadata: {
    title: 'Mirror- Aware.dev',
    description: 'Mirror .brs saves.',
    meta: [
      { property: 'og:title', content: 'Mirror' },
      { property: 'og:description', content: 'Mirror .brs saves.' },
      { property: 'og:url', content: 'https://aware.dev/tools/mirror' },
      // { property: 'og:image', content: 'https://i.imgur.com/OHaRlCM.png' },
      // { property: 'og:image:alt', content: 'Img2Brs Logo' },
    ]
  },
  children: []
}

export const ResizeNav = {
  label: 'Resize',
  description: 'Resize .brs saves.',
  url: '/tools/resize',
  metadata: {
    title: 'Resize - Aware.dev',
    description: 'Resize .brs saves.',
    meta: [
      { property: 'og:title', content: 'Resize' },
      { property: 'og:description', content: 'Resize .brs saves.' },
      { property: 'og:url', content: 'https://aware.dev/tools/resize' },
      // { property: 'og:image', content: 'https://i.imgur.com/OHaRlCM.png' },
      // { property: 'og:image:alt', content: 'Img2Brs Logo' },
    ]
  },
  children: []
}

export const PlateNav = {
  label: 'Plate',
  description: 'Plate .brs saves.',
  url: '/tools/plate',
  metadata: {
    title: 'Plate - Aware.dev',
    description: 'Plate .brs saves.',
    meta: [
      { property: 'og:title', content: 'Plate' },
      { property: 'og:description', content: 'Plate .brs saves.' },
      { property: 'og:url', content: 'https://aware.dev/tools/plate' },
      // { property: 'og:image', content: 'https://i.imgur.com/OHaRlCM.png' },
      // { property: 'og:image:alt', content: 'Img2Brs Logo' },
    ]
  },
  children: []
}

export const ColorListNav = {
  label: 'Color List',
  description: 'A list of all colors in Brickadia.',
  url: '/tools/colors',
  metadata: {
    title: 'Color List - Aware.dev',
    description: 'A list of all colors in Brickadia.',
    meta: [
      { property: 'og:title', content: 'Color List' },
      { property: 'og:description', content: 'A list of all colors in Brickadia.' },
      { property: 'og:url', content: 'https://aware.dev/tools/colors' },
    ]
  },
  children: []
}

export const SpywareNav = {
  label: 'Spyware',
  description: 'For spying.',
  url: '/tools/spyware',
  metadata: {
    title: 'Spyware - Aware.dev',
    description: 'For spying.',
    meta: [
      { property: 'og:title', content: 'Spyware' },
      { property: 'og:description', content: 'For spying.' },
      { property: 'og:url', content: 'https://aware.dev/tools/spyware' },
    ]
  },
  children: []
}

export const MaterialNav = {
  label: 'Material',
  description: 'Adjust materials of a BRS file.',
  url: '/tools/material',
  metadata: {
    title: 'Material - Aware.dev',
    description: 'Adjust materials of a BRS file.',
    meta: [
      { property: 'og:title', content: 'Material Modifier' },
      { property: 'og:description', content: 'Adjust materials of a BRS file.' },
      { property: 'og:url', content: 'https://aware.dev/tools/material' },
    ]
  },
  children: []
}

export const ModifyNav = {
  label: 'Modify',
  description: 'Modify .brs saves.',
  url: '/tools/modify',
  metadata: {
    title: 'Modify - Aware.dev',
    description: 'Modify .brs saves.',
    meta: [
      { property: 'og:title', content: 'Modify' },
      { property: 'og:description', content: 'Modify .brs saves.' },
      { property: 'og:url', content: 'https://aware.dev/tools/modify' },
      // { property: 'og:image', content: 'https://i.imgur.com/OHaRlCM.png' },
      // { property: 'og:image:alt', content: 'Img2Brs Logo' },
    ]
  },
  children: []
}




export const ToolsNav = {
  label: 'Tools',
  description: 'Check out my tools!',
  url: '/tools',
  children: [
    Img2BrsNav,
    IllegalGeneratorNav,
    Brs2JsonNav,
    Json2BrsNav,
    VersionNav,
    MirrorNav,
    ResizeNav,
    PlateNav,
    ColorListNav,
    SpywareNav,
    MaterialNav,
    ModifyNav
  ]
}

export const HeaderNavList = [
  ToolsNav
]

export const NavList = [
  Img2BrsNav,
  ToolsNav,
  IllegalGeneratorNav,
  Brs2JsonNav,
  Json2BrsNav,
  VersionNav,
  MirrorNav,
  ResizeNav,
  PlateNav,
  ColorListNav,
  SpywareNav,
  MaterialNav,
  ModifyNav
]

export const NavMap = NavList.reduce((prevValue, value) => {
  return { ...prevValue, [value.url]: value }
}, {})
